import * as React from 'react';
import MemberAddress from '../MakeDonation/Types/MemberAddress';

class StringFormatter {
  static numberAsCurrency(value: number): string {
    let asString = `${value}`;

    while (asString.length < 3) {
      asString = '0' + asString;
    }

    return (
      asString.substring(0, asString.length - 2) +
      '.' +
      asString.substring(asString.length - 2)
    );
  }

  static numberAsOrdinal(n: number): string {
    var s = ['th', 'st', 'nd', 'rd'],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  static FormatPersonName(title: string, firstName: string, lastName: string) {
    let name = firstName + ' ' + lastName;

    if (title && title.length > 0) {
      return title + ' ' + name;
    }

    return name;
  }

  static FormatAddress(address: MemberAddress): JSX.Element {
    return (
      <>
        {this.ExcludeNullEmpty(address.line1)}
        {this.ExcludeNullEmpty(address.line2)}
        {this.ExcludeNullEmpty(address.line3)}
        {this.ExcludeNullEmpty(address.town)}
        {this.ExcludeNullEmpty(address.county)}
        {this.ExcludeNullEmpty(address.postcode)}
        {this.ExcludeNullEmpty(address.country)}
      </>
    );
  }

  static ExcludeNullEmpty = (s: string) => {
    if (!s || s.length === 0) {
      return;
    }

    return (
      <>
        {s}
        <br />
      </>
    );
  };

  static GetFullMonth(month: number): string {
    const monthName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return monthName[month];
  }

}

export default StringFormatter;



// WEBPACK FOOTER //
// ./src/Helpers/StringFormatter.tsx